/**
 * Hero: neighborhood (small caps) + restaurant name (large). The spot is chosen via the location
 * autocomplete (PlacePicker); a launch param pre-fills the name. "change" reopens the picker.
 */
import { useState } from 'react';
import { PlacePicker } from './PlacePicker.js';

interface HeroProps {
  restaurant: string;
  neighborhood: string;
  onName: (name: string) => void;
  onSelectPlace: (name: string, neighborhood: string, placeId: string | undefined, isNew: boolean) => void;
}

export function Hero({ restaurant, neighborhood, onName, onSelectPlace }: HeroProps) {
  const [editing, setEditing] = useState(restaurant.trim() === '');

  return (
    <section className="hero">
      {neighborhood && !editing && <p className="hero-neighborhood">{neighborhood}</p>}

      {!editing && restaurant ? (
        <div className="hero-named">
          <h1 className="hero-name">{restaurant}</h1>
          <button type="button" className="hero-change" onClick={() => setEditing(true)}>
            change
          </button>
        </div>
      ) : (
        <PlacePicker
          value={restaurant}
          onName={onName}
          onSelect={(name, nb, placeId, isNew) => {
            onSelectPlace(name, nb, placeId, isNew);
            setEditing(false);
          }}
        />
      )}
    </section>
  );
}
